// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3MdeW","name":"styles_name__3uOm8","date":"styles_date__1n9U6"};